// src/components/SubscriptionBilling.jsx
import { glassCard } from '../styles/glass';
import { useNavigate } from 'react-router-dom';
import { useReduxStore } from '../hooks/useReduxStore';
import { CancelSubscription, RenewSubscription } from '../store/Actions/action';
import { useMemo } from 'react';

export default function SubscriptionBilling({ isAdminCreated }) {
  const navigate=useNavigate()
  const {getState,dispatch}=useReduxStore()
  const {subscription}=getState("AUTH")
  // const activePlan = {
  //   name:subscription?.length?subscription[0]?.planId?.name: 'Free',
  //   status: 'Active',
  //   price:subscription?.length? subscription[0]?.planId?.price:0,
  //   duration: 'Monthly',
  // };
const activePlan=useMemo(()=>{
let obj=subscription.find((p)=>p?.planId?.price>0)
if(obj!==null){
return {
      name:obj?.planId?.name,
    price:obj?.planId?.price,
    duration: 'Monthly',
    ...obj
}
}
else{
return null
}
},[subscription])  
let isCancelled=activePlan?.status==="canceled"?true:false
const freePlan={
     name:'Free',
    status: 'Active',
    price:0,
    duration: 'ALL Time',
}
  // const alerts = [
  //   { title: 'Heavy Rain Warning', location: 'Karachi' },
  //   { title: 'Heatwave Alert', location: 'Lahore' },
  //   { title: 'Dust Storm Warning', location: 'Quetta' },
  // ];
const onUpgradeClick=()=>{
    navigate("/pricing")
}
const onCancelSubscription=()=>{
  dispatch(CancelSubscription({id:activePlan?._id}))
}
const onRenewSubscription=()=>{
  dispatch(RenewSubscription({id:activePlan?._id}))
}
  return (
    
    <div className="h-full">
      {activePlan?._id ? (
       <div className={`h-full min-h-[30vh] ${glassCard}`}>
  {/* Header */}
   <h2 className="text-2xl font-semibold text-white mb-6">Subscription & Billing</h2>

  <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
    <h3 className="text-xl font-semibold text-white">{activePlan.name}</h3>
    <div className="flex flex-wrap items-center gap-2">
   { <span className="text-xs bg-primaryBlue text-white px-2 py-1 rounded-full">
        Active
      </span>}
      {isCancelled && (
        <span className="text-xs bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full">
          Will not renew
        </span>
      )}
    </div>
  </div>

  {/* Price */}
  <div className="text-4xl font-bold text-white mb-1">
    ${activePlan.price}
    <span className="text-base font-medium text-gray-200 ml-1">/ {activePlan.duration}</span>
  </div>
{isCancelled&&  <p className="text-sm text-gray-200 mt-3">
    	Your subscription has been cancelled and will not renew automatically.
  </p>}
  {/* Validity Info */}
{!isAdminCreated&& <p className="text-xs font-medium text-gray-200  mb-8 mt-3 bg-blue-gray-500 p-2 w-fit rounded-3xl px-4">
    {isCancelled
      ? `Ends on  ${new Date(activePlan.currentPeriodEnd)?.toLocaleDateString()}`
      : `Renews on ${new Date(activePlan.currentPeriodEnd)?.toLocaleDateString()}`}
  </p>}


  {/* Button */}
  {isAdminCreated?null: isCancelled ? (
    <button
      onClick={onRenewSubscription}
      className="w-full mt-2  font-medium bg-primaryBlue text-white py-3 rounded-md hover:bg-primaryBlue/90 text-base transition"
    >
      Don't cancel subscription
    </button>
  ) : (
    <button
      onClick={onCancelSubscription}
      className="w-full font-medium  bg-primaryBlue  text-white py-3 rounded-md hover:bg-primaryBlue/95 text-base transition mt-12"
    >
      Cancel Subscription
    </button>
  )}
      </div>
      ) : (
          <div className={`h-full min-h-[30vh] ${glassCard} p-4`}>
          <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <h3 className="text-xl font-semibold text-white">{freePlan?.name}</h3>
            <span className="text-xs bg-primaryBlue text-white px-2 py-1 rounded w-fit">
              {freePlan.status}
            </span>
          </div>
          <div className="text-5xl mb-4 font-bold text-white">${freePlan.price}</div>
          <div className="text-sm text-gray-200 mb-12">{freePlan.duration}</div>

        <button onClick={onUpgradeClick} className="w-full  bg-primaryBlue text-white py-3 rounded hover:bg-primaryBlue/95 text-sm">
            Upgrade Subscription
          </button>
        </div>
      )}
    </div>
  );
}
